module.exports = __webpack_public_path__ + "img/proveedores.3137ba5a.png";